export default __webpack_public_path__ + "static/media/mail1.f048615b.svg";